import React, { useContext, useState } from 'react'
import { IoArrowBackCircleSharp } from "react-icons/io5";
import chegg from "../../assets/chegg.jpg"
import Prodigy from "../../assets/Prodigy-offer.jpg"
import Codtech from "../../assets/Codtech-offer.jpg"
import "./exp.css";
import { FaWindowClose } from "react-icons/fa";
import { FaRegWindowClose } from "react-icons/fa";
import { UserContext } from '../../App';
import {motion} from 'framer-motion';
import {fadeIn} from '../variants';


function Exp() {
    const {theme,setTheme}=useContext(UserContext);
    const [Chegg,setChegg]=useState(0);
    const [Prod,setProd]=useState(0);
    const [Cod,setCod]=useState(0);


    function viewDetails1(){
        setChegg(1);
    }
    function viewDetails2(){
        setProd(1);
    }
    function viewDetails3(){
        setCod(1);
    }

  return (
    <>

     <div className='exp-main'>

    <div className={theme==0?"exp-main-light":"exp-main-dark" }>
        <div className='exp-contex'>
        <center style={{paddingTop:"0rem"}}>
            <h3 id={theme==0?"type-light":"type-dark"}>Experience</h3>

        </center>
        <div id="cards" className='exp-cards'>
            {
                Chegg==0?
                
                <motion.div
                variants={fadeIn("up",0.2)}
                initial="hidden"
                whileInView={"show"}
                viewport={{once:false,amount:0.7}}
                className={theme==0?'exp-section-light':"exp-section-dark"}>
        

                    <span id={theme==0?"role-light":"role-dark"}>CS Chegg Expert</span> 
                    <h3>CHEGG INDIA PVT.LTD</h3> 
                    <h4>Duration - 4 Months</h4> 
                    <span className='details' onClick={viewDetails1}>
                    View <IoArrowBackCircleSharp/>
                    </span>
                </motion.div>
                :
                    <div className='exp-view'>
                         <span onClick={()=>setChegg(0)}>{theme==0?<span id="svg">close<FaWindowClose/></span>:<span id="svg">Close<FaRegWindowClose/></span>}</span>
                       <a href="http://localhost:3000/static/media/chegg.b88134126d0cf3158866.jpg" target='_black'><img style={{borderRadius:"1rem"}} id={theme==0?"border-light":"border-dark"}  src={chegg} alt="chegg" width="200px"/></a>
                    </div>
            }

        
        {Cod==0?
                <motion.div
                variants={fadeIn("up",0.2)}
                initial="hidden"
                whileInView={"show"}
                viewport={{once:false,amount:0.7}}
                className={theme==0?'exp-section-light':"exp-section-dark"}>
                
    
                <span id={theme==0?"role-light":"role-dark"}>Full Stack Web Development Internship</span> 
                <h3>CODTECH IT SOLUTIONS PVT.LTD</h3> 
                <h4>5th September , 2024 To 5th October, 2024</h4> 
                <span className='details' onClick={viewDetails3}>
                       <span>View </span>
                     < IoArrowBackCircleSharp/>
                </span>
            </motion.div>
            :
            <div className='exp-view'>
            <span onClick={()=>setCod(0)}>{theme==0?<span id="svg">close<FaWindowClose/></span>:<span id="svg">Close<FaRegWindowClose/></span>}</span>
            <a href="http://localhost:3000/static/media/Codtech-offer.4587362a1f39fc113b44.jpg" target='_black'><img style={{borderRadius:"1rem"}}  id={theme==0?"border-light":"border-dark"} src={Codtech} alt="Codtech" width="200px"/></a>
            </div>
        }


 
        </div>

        </div>
    </div>
    </div>
    </>
  )
}

export default Exp
